/**
 * Initial state for the coinsReducer, representing an empty array.
 */
const initialState = [];

/**
 * Reducer function for handling changes to the coins state in the Redux store.
 * @param {Array} state - The current state of the coins in the Redux store.
 * @param {Object} action - An action object with a type and payload to specify the modification.
 * @returns {Array} The new state of coins after applying the specified modification.
 */
const coinsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Action to set the entire list of coins in the state
    case "SET_COINS":
      return payload;

    // Action to mark a specific coin as starred
    case "SETSTARRED_COIN":
      let starredData = [...state].map((elem) => {
        if (elem.id === payload) {
          elem.starred = true;
        }
        return elem;
      });
      return starredData;

    // Action to unmark the starred status of a specific coin
    case "UNSETSTARRED_COIN":
      let unstarredData = [...state].map((elem) => {
        if (elem.id === payload) {
          elem.starred = false;
        }
        return elem;
      });
      return unstarredData;

    // Default case, returns the current state for unknown actions
    default:
      return state;
  }
};

export default coinsReducer;
